/**
 * @class Oskari.mapframework.bundle.toolbar.request.ToolbarRequestHandler
 * Handles Oskari.mapframework.bundle.toolbar.request.AddToolbarRequest,
 * Oskari.mapframework.bundle.toolbar.request.RemoveToolbarRequest and
 * Oskari.mapframework.bundle.toolbar.request.ToolButtonStateRequest
 *  for managing toolbar buttons
 */
Oskari.clazz.define('Oskari.mapframework.bundle.toolbar.request.ToolbarRequestHandler',
/**
 * @method create called automatically on construction
 * @static
 * @param {Oskari.mapframework.bundle.toolbar.ToolbarBundleInstance} toolbar
 *          reference to toolbarInstance that handles the buttons
 */
function (toolbar) {
  this._toolbar = toolbar;
}, {
  /**
   * @method handleRequest
   * Hides the requested infobox/popup
   * @param {Oskari.mapframework.core.Core} core
   *      reference to the application core (reference sandbox core.getSandbox())
   * @param {Oskari.mapframework.bundle.toolbar.request.AddToolbarRequest/Oskari.mapframework.bundle.toolbar.request.RemoveToolbarRequest/Oskari.mapframework.bundle.toolbar.request.ToolButtonStateRequest} request
   *      request to handle
   */
  handleRequest: function handleRequest(core, request) {
    var requestOperation = request.getOp();
    if (requestOperation === 'add') {
      this._toolbar._addToolbar(request.getId(), request.getData());
    } else if (requestOperation === 'show') {
      this._toolbar._showToolbar(request.getId());
    } else if (requestOperation === 'hide') {
      this._toolbar._hideToolbar(request.getId());
    } else if (requestOperation === 'remove') {
      this._toolbar._removeToolbar(request.getId());
    } else if (requestOperation === 'changeName') {
      this._toolbar.changeMenuToolbarTitle(request.getData());
    } else if (requestOperation === 'update') {
      this._toolbar._updateToolbar(request.getId(), request.getData());
    }
  },
  _handleAdd: function _handleAdd(sandbox, request) {
    this._toolbar.addToolButton(request.getId(), request.getGroup(), request.getConfig());
  },
  _handleRemove: function _handleRemove(sandbox, request) {
    this._toolbar.removeToolButton(request.getId(), request.getGroup());
  },
  _handleState: function _handleState(sandbox, request) {
    this._toolbar.changeToolButtonState(request.getId(), request.getGroup(), request.getState());
  },
  _handleClick: function _handleClick(sandbox, request) {
    this._toolbar._clickButton(request.getId(), request.getGroup());
  }
}, {
  /**
   * @property {String[]} protocol array of superclasses as {String}
   * @static
   */
  protocol: ['Oskari.mapframework.core.RequestHandler']
});